module.exports = __webpack_public_path__ + "img/ball-park.88c9d567.png";